import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
// Languages
import de from "./de.json";
import el from "./el.json";
import en from "./en.json";
import es from "./es.json";
import fr from "./fr.json";
import nl from "./nl.json";
import pt from "./pt.json";
import ro from "./ro.json";
import ru from "./ru.json";
import tr from "./tr.json";
import th from "./th.json";
import sk from "./sk.json";
import id from "./id.json";
import bs from "./bs.json";
import bg from "./bg.json";
import pl from "./pl.json";
import zhtw from "./zhtw.json";
import ko from "./ko.json";
import zhcn from "./zhcn.json";
import hu from "./hu.json";
import { languageCodes } from "../config";
import store from "redux/store";

// the translations
let resources = {
  en: { translation: en },
  es: { translation: es },
  pt: { translation: pt },
  de: { translation: de },
  nl: { translation: nl },
  fr: { translation: fr },
  tr: { translation: tr },
  ro: { translation: ro },
  el: { translation: el },
  ru: { translation: ru },
  th: { translation: th },
  sk: { translation: sk },
  id: { translation: id },
  bs: { translation: bs },
  bg: { translation: bg },
  pl: { translation: pl },
  zhtw: { translation: zhtw },
  zhcn: { translation: zhcn },
  ko: { translation: ko },
  hu: { translation: hu },
};

export const updateLang = () => {
  let val = {};
  if (
    store.getState() &&
    store.getState().translation &&
    store.getState().translation.i18n
  ) {
    val = store.getState().translation.i18n;
    let length = Object.keys(val).length;
    for (let i = 0; i < length; i++) {
      let key = Object.keys(val)[i];
      if (key && key != "version") {
        // console.log(Object.keys(val)[i]);
         resources[key] ={ translation:val[key]}
        // console.log(I18n.translations[key]);
      }
    }
  }
};
export const defaultLanguage = languageCodes.english;

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    // lng: "es", // This will set default language and overwrite languageDetector
    fallbackLng: defaultLanguage, // use en if detected lng is not available
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });
// Use this for displaying options to the user on UI. This way all the language related config stays at one place.

export default i18n;
